import '../../../styles/Messaging.css';
import { MdForwardToInbox } from "react-icons/md";
import { GrInbox } from "react-icons/gr";
import { BsSendArrowUp } from "react-icons/bs";
import React from "react";
import { useUnreadMessages } from '../../../hooks/useUnreadMessages.ts';
import { useUser } from '../../../context/UserContext.tsx';

interface MessagingProps {
    onViewChange: (view: string) => void;
    activeView?: string;
}

const Messaging = ({ onViewChange, activeView = 'inbox' }: MessagingProps) => {
    const { user: currentUser } = useUser();
    const { unreadCount } = useUnreadMessages(currentUser?.userName);

    const navItems = [
        { key: 'compose', label: 'COMPOSE', icon: <MdForwardToInbox className='icon-compose' />, className: 'btn-danger body-customer' },
        { key: 'inbox', label: 'INBOX', icon: <GrInbox className='icon-compose' />, className: 'btn-success body-customer', badge: unreadCount },
        { key: 'sent', label: 'SENT', icon: <BsSendArrowUp className='icon-compose' />, className: 'btn-primary body-customer' },
    ];

    return (
        <div className='mt-2 container-messag'>
            <div className="inbox-header">
                <span>MESSAGING</span>
            </div>
            <div className="line-block-messag"></div>
            {navItems.map((item, index) => (
                <div key={item.key} className={`${index > 0 ? 'mt-2' : ''} d-flex justify-content-center`}>
                    <button
                        className={`buttonS btn ${item.className} messaging-nav-btn`}
                        onClick={() => onViewChange(item.key)}
                    >
                        {item.icon}{item.label}
                        {item.badge != null && item.badge > 0 && (
                            <span className="messaging-nav-badge">
                                {item.badge > 99 ? '99+' : item.badge}
                            </span>
                        )}
                    </button>
                </div>
            ))}
        </div>
    );
};

export default Messaging;
